export enum ErrorCode {
  NoLogin = 3,
  NoLoginDenied = 64,
}
